import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _Array$isArray from "@babel/runtime-corejs3/core-js/array/is-array";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js/instance/some";
import _reduceRightInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce-right";
/* eslint-disable  import/prefer-default-export */
import React from "react";
const isListOfComponents = t => _Array$isArray(t);
const someChangedIdentity = (left, right) => _someInstanceProperty(left).call(left, (el, i) => el !== right[i]);
const createComponentFromAs = as => {
  if (isListOfComponents(as)) {
    const result = _reduceRightInstanceProperty(as).call(as, (Accumulator, LeftComp) => {
      const L = LeftComp;
      const NewComp = props => /*#__PURE__*/React.createElement(L, _extends({
        as: Accumulator
      }, props));
      return NewComp;
    });
    return result;
  }
  return as;
};
export const useAsProp = as => {
  const prevAsValueRef = React.useRef(as);
  const prevAsValue = prevAsValueRef.current;
  const toRenderRef = React.useRef(createComponentFromAs(as));
  const arrayChangedSize = _Array$isArray(as) && _Array$isArray(prevAsValue) && (prevAsValue.length !== as.length || someChangedIdentity(prevAsValue, as));
  const propChangedType = _Array$isArray(prevAsValue) !== _Array$isArray(as) && typeof prevAsValue !== typeof as;
  if (arrayChangedSize || propChangedType) {
    toRenderRef.current = createComponentFromAs(as);
  }
  prevAsValueRef.current = as;
  return toRenderRef.current;
};